module.exports = "/images/gotham-8.jpg";